import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-successful-timesheet-settlement',
  templateUrl: './successful-timesheet-settlement.component.html',
  styleUrls: ['./successful-timesheet-settlement.component.scss'],
  standalone: false
})
export class SuccessfulTimesheetSettlementComponent implements OnInit {
  private route = inject(ActivatedRoute);

  startDate: Date;
  endDate: Date;

  constructor() { }

  ngOnInit(): void {
    this.startDate = this.route.snapshot.queryParams.startDate;
    this.endDate = this.route.snapshot.queryParams.endDate;
  }
}
